import {
    FETCH_FORMATION_BOOKMARKS_FAIL,
    FETCH_FORMATION_BOOKMARKS_REQUEST,
    FETCH_FORMATION_BOOKMARKS_SUCCESS,
    TOGGLE_FORMATION_BOOKMARK_FAIL,
    TOGGLE_FORMATION_BOOKMARK_REQUEST,
    TOGGLE_FORMATION_BOOKMARK_SUCCESS,
} from "../actions/formationBookmarksActions";

const initialState = {
    loading: false,
    toggling: false,
    error: null,
    bookmarksByCampagneId: {},
};

const normalizeFormationId = (item) => String(item?.formationId || item?.id || "");

export default function formationBookmarksReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_FORMATION_BOOKMARKS_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_FORMATION_BOOKMARKS_SUCCESS: {
            const campagneId = String(action.payload?.campagneId || "");
            return {
                ...state,
                loading: false,
                error: null,
                bookmarksByCampagneId: {
                    ...state.bookmarksByCampagneId,
                    [campagneId]: Array.isArray(action.payload?.data) ? action.payload.data : [],
                },
            };
        }

        case FETCH_FORMATION_BOOKMARKS_FAIL:
            return { ...state, loading: false, error: action.payload?.error || action.payload };

        case TOGGLE_FORMATION_BOOKMARK_REQUEST:
            return { ...state, toggling: true, error: null };

        case TOGGLE_FORMATION_BOOKMARK_SUCCESS: {
            const campagneId = String(action.payload?.campagneId || "");
            const formationId = String(action.payload?.formationId || "");
            const current = state.bookmarksByCampagneId[campagneId] || [];
            const filtered = current.filter((item) => normalizeFormationId(item) !== formationId);
            const next = action.payload?.bookmarked
                ? [
                    {
                        ...(action.payload?.formation || {}),
                        id: Number(formationId),
                        formationId: Number(formationId),
                        campagneId: Number(campagneId),
                        bookmarked: true,
                    },
                    ...filtered,
                ]
                : filtered;

            return {
                ...state,
                toggling: false,
                error: null,
                bookmarksByCampagneId: {
                    ...state.bookmarksByCampagneId,
                    [campagneId]: next,
                },
            };
        }

        case TOGGLE_FORMATION_BOOKMARK_FAIL:
            return { ...state, toggling: false, error: action.payload };

        default:
            return state;
    }
}
